import { render, staticRenderFns } from "./TypeCompound.vue?vue&type=template&id=fd94c12e&"
import script from "./TypeCompound.vue?vue&type=script&lang=js&"
export * from "./TypeCompound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports